import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import api from '../api'

// Halaman CETAK standalone -- sengaja TIDAK dibungkus <Layout /> (pola sama persis
// PayrollSlipCetak.jsx, dibaca sbg referensi). Dibuka via window.open() dari tombol Cetak di
// Voucher.jsx, di TAB BARU -- jadi window.print() otomatis cuma nyetak grid voucher ini.
// Beda dari PayrollSlipCetak.jsx: identifier lewat query string, DUA mode --
//   ?catatan=  -> cetak 1 BATCH utuh (dipakai tombol Cetak di modal hasil generate)
//   ?ids=1,2,3 -> cetak voucher TERPILIH SAJA (2026-07-25, bug report: cetak 1 baris di tabel
//   Voucher dulu keliru nyetak SELURUH batch krn cuma ada mode catatan -- sekarang tabel pakai
//   checkbox pilih + cetak per-baris, keduanya lewat ids, bukan catatan lagi)
export default function VoucherCetak() {
  const [params] = useSearchParams()
  const catatan = params.get('catatan') || ''
  const ids = params.get('ids') || ''
  const [items, setItems] = useState(null)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!catatan && !ids) { setError('Voucher yang mau dicetak tidak ditemukan'); return }
    api.get('/voucher', { params: ids ? { ids, limit: 500 } : { catatan, limit: 500 } })
      .then(res => setItems(res.data.items))
      .catch(e => setError(e.response?.data?.message || 'Gagal memuat voucher'))
  }, [catatan, ids])

  useEffect(() => {
    if (!items || items.length === 0) return
    const t = setTimeout(() => window.print(), 400)
    return () => clearTimeout(t)
  }, [items])

  if (error) return <div style={{ padding: 40, fontFamily: 'sans-serif', color: '#b00' }}>{error}</div>
  if (!items) return <div style={{ padding: 40, fontFamily: 'sans-serif' }}>Memuat...</div>
  if (items.length === 0) return <div style={{ padding: 40, fontFamily: 'sans-serif' }}>Tidak ada voucher pada batch ini</div>

  return (
    <div style={{ maxWidth: 900, margin: '24px auto', padding: '0 20px', fontFamily: 'sans-serif' }}>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
        {items.map(v => (
          <div key={v.id} style={{
            border: '1px dashed #999', borderRadius: 6, padding: '10px 12px',
            breakInside: 'avoid', textAlign: 'center'
          }}>
            <div style={{ fontSize: 10, color: '#666', textTransform: 'uppercase', letterSpacing: 0.4 }}>{v.nama_paket}</div>
            <div style={{ fontSize: 16, fontWeight: 700, fontFamily: 'monospace', margin: '4px 0' }}>{v.kode}</div>
            {v.password !== v.kode && (
              <div style={{ fontSize: 11, color: '#333' }}>Password: <span style={{ fontFamily: 'monospace' }}>{v.password}</span></div>
            )}
            <div style={{ fontSize: 11, color: '#333', marginTop: 2 }}>Rp {Number(v.harga_jual).toLocaleString('id-ID')}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
